import { Box, useTheme } from "@mui/material";
import Table, { RowData, Column } from "../Table";

interface SubTable {
  title: string;
  columns: Column[];
  data: RowData[];
}

interface Props {
  title: string;
  tables: SubTable[];
}

const NestedTable: React.FC<Props> = ({ title, tables }) => {
  const theme = useTheme();

  return (
    <Box sx={{ borderBottom: `1px solid ${theme.palette.primary.main}` }}>
      <Box
        sx={{
          padding: "1rem",
          background: theme.palette.primary.main,
          color: "#fff",
          textTransform: "uppercase",
          fontSize: "0.875rem",
          fontWeight: 600,
        }}
      >
        {title}
      </Box>
      {tables.map(({ title, columns, data }) => (
        <Box key={title}>
          <Table
            columns={[
              {
                key: "__subtable_title__",
                label: title,
              },
              ...columns,
            ]}
            data={data}
            dense
            nested
            hasPagination={false}
          />
        </Box>
      ))}
    </Box>
  );
};

export default NestedTable;
